import { ErrorHandler, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsErrorEventProvider } from '../providers/error-event-provider';
import { HttpErrorResponse } from '@angular/common/http';

export class AnalyticsErrorHandler implements ErrorHandler {
  private readonly analyticsService = inject(AnalyticsErrorEventProvider);
  private readonly router = inject(Router);

  handleError(error: unknown) {
    if (error instanceof HttpErrorResponse) {
      this.handleHttpError(error);
      return;
    }

    const url = this.router.url;

    this.analyticsService.createAndPush({
      error_action: `UncaughtError on ${url}`,
      field_name: 'UncaughtError',
      error,
    });
  }

  private handleHttpError(error: HttpErrorResponse) {
    const url = this.router.url;

    let errorAction = `UncaughtError on ${url}`;

    const innerError = error.error;
    if (innerError.instance !== undefined) {
      errorAction = `UncaughtError on ${innerError.instance}`;
    }

    this.analyticsService.createAndPush({
      error_action: errorAction,
      field_name: 'HttpError',
      error,
    });
  }
}
